import React, { useState } from "react";
import { Tabs, Tab, FILL } from "baseui/tabs-motion";
import TemplatePropertiesAsideView from "./TemplatePropertiesAsideView";
import TemplateModelerPropertiesAsideView from "./TemplateModelerPropertiesAsideView";
import { FaTasks, FaFolderOpen } from "react-icons/fa";

export default function TemplateEditorAsideView(props) {
  const [activeKey, setActiveKey] = React.useState("0");
  const [modelerThumbnailImage, setModelerThumbnailImage] = useState(undefined);
  const [templateThumbnailImage, setTemplateThumbnailImage] = useState(undefined);
  
  function handleModelerImageFileUpload(acceptedFiles, imageFile) {
    props.handleModelerFileUpload(acceptedFiles);
    setModelerThumbnailImage(imageFile);
  }
  function handleTemplateImageFileUpload(acceptedFiles, imageFile) {
    props.handleTemplateFileUpload(acceptedFiles);
    setTemplateThumbnailImage(imageFile);
  }
  return (
    <Tabs
      fill={FILL.fixed}
      onChange={({ activeKey }) => {
        setActiveKey(activeKey);
      }}
      activeKey={activeKey}
    >
      <Tab title="Template" artwork={FaTasks}>
        <TemplatePropertiesAsideView
          thumbnailImage={templateThumbnailImage}
          handleUploadImageFile={handleTemplateImageFileUpload}
        />
      </Tab>
      <Tab title="Modeler" artwork={FaFolderOpen}>
        <TemplateModelerPropertiesAsideView
          thumbnailImage={modelerThumbnailImage}
          handleUploadImageFile={handleModelerImageFileUpload}
        />
      </Tab>
    </Tabs>
  );
}
